/**
 * ビルド時の環境変数で切り替える機能フラグ。
 * Cloudflare Pages 等の環境変数で環境ごとに上書きする。
 */

// 正式サービス開始前ゲート。true の間、機能ページは「準備中」表示になる。
// 未設定/false で全機能開放。
export const COMING_SOON = import.meta.env.VITE_COMING_SOON === 'true';

// 課金機能の有効/無効。既定は有効。'false' のときだけ無効化する。
// dev/検証環境（例: dev.otomochi.com）で課金導線をテスターに触らせない用途。
// 無効時: 課金ナビ・プラン変更ボタンを非表示にし、/billing 系ルートを遮断する。
export const BILLING_ENABLED = import.meta.env.VITE_BILLING_ENABLED !== 'false';

// テスト環境モード（dev公開テスト用）。true の間: 書き起こしは無制限・ダウンロードは無効。
export const TEST_MODE = import.meta.env.VITE_TEST_MODE === 'true';

// ダウンロード可否。テスト環境では無効化する（あくまで動作確認用のため）。
export const DOWNLOADS_ENABLED = !TEST_MODE;
